import React from "react";
import { Typography } from "antd";
import { UserIdentity } from "@/shared/components";
import { createStyles } from "antd-style";

const { Text } = Typography;

const useStyles = createStyles(({ token, css }) => ({
  link: css`
    cursor: pointer;
    color: ${token.colorPrimary};
    background: none;
    border: none;
    padding: 0;
    text-align: left;
    line-height: 1.4;
    &:hover {
      text-decoration: underline;
    }
  `,
  name: css`
    font-size: 12px;
    font-weight: 500;
  `,
  email: css`
    font-size: 10px;
    color: ${token.colorTextTertiary};
  `,
}));

export interface UserCellProps {
  userId?: string | null;

  userMap: Record<string, AuthAPI.AdminUser>;

  onOpen?: (numericUserId: number) => void;

  fallbackName?: string;

  fallbackEmail?: string;
}

const UserCell: React.FC<UserCellProps> = ({
  userId,
  userMap,
  onOpen,
  fallbackName,
  fallbackEmail,
}) => {
  const { styles } = useStyles();

  if (!userId) {
    return <Text type="secondary">-</Text>;
  }
  const u = userMap[userId];
  const display = u?.profile?.nickname || u?.email;

  if (u && display) {
    return (
      <button
        type="button"
        className={styles.link}
        onClick={(e) => {
          e.stopPropagation();
          if (onOpen) onOpen(u.userId);
        }}
      >
        <UserIdentity
          size={28}
          avatar={u.profile?.avatar}
          name={display}
          email={u.email}
          textStyle={{ maxWidth: 180 }}
        />
      </button>
    );
  }

  if (fallbackName) {
    return (
      <span>
        <div className={styles.name}>{fallbackName}</div>
        {fallbackEmail ? (
          <div className={styles.email}>{fallbackEmail}</div>
        ) : null}
      </span>
    );
  }

  return (
    <Text type="secondary" style={{ fontFamily: "monospace", fontSize: 11 }}>
      …{userId.slice(-8)}
    </Text>
  );
};

export default UserCell;
